import { formatBalance } from "@polkadot/util";
import { encodeAddress } from "@polkadot/util-crypto";

export const formatAmount = (
  amount: string,
  unit: string = "ANLOG",
  withSi: boolean = true
) => {
  if (withSi) {
    return formatBalance(amount, {
      decimals: 12,
      withUnit: unit,
    });
  } else {
    return (parseFloat(amount) / 10 ** 12).toString();
  }
};

export function convertToAnalogAddress(walletAddress: string) {
  return encodeAddress(walletAddress, 12850);
}

export const formatForExtrinsic = (amount: string) => {
  return BigInt(parseFloat(`${parseFloat(amount) * 10 ** 12}`).toFixed(0));
};